<template>
  <table class="fgbttm_table">
    <tr>
      <td>
        <div class="fgbttm_leist fgbttm_block chart_wrapper">
          <h3>Leistungsbereiche<br />&nbsp;</h3>
          <table>
            <tr v-for="row in data">
              <td>{{ row[2] }}</td>
            </tr>
          </table>
        </div>
      </td>
      <td>
        <div class="fgbttm_honorar fgbttm_block chart_wrapper">
          <h3>Honoraranteile<br />{{ quartalText }}</h3>
          <table>
            <tr v-for="row in data">
              <td>
                {{
                  row[5].toLocaleString("de-DE", {
                    minimumFractionDigits: 0,
                  })
                }}€
              </td>
            </tr>
          </table>
        </div>
      </td>
      <td>
        <div class="fgbttm_leistungen fgbttm_block chart_wrapper">
          <h3>
            Leistungsbereiche im Vergleich<br />zum Vorjahresquartal (VJQ)
          </h3>
          <canvas
            id="canvas_fgbttm"
            width="485"
            height="271"
            ref="chart"
          ></canvas>
        </div>
      </td>
      <td>
        <div class="fgbttm_leist fgbttm_block chart_wrapper">
          <h3>Veränderung<br />zum VJQ</h3>
          <table>
            <tr v-for="row in data">
              <td>
                {{ row[7] < 0 ? "- " : "+ " }}
                {{
                  Math.abs(row[7]).toLocaleString("de-DE", {
                    minimumFractionDigits: 0,
                    maxFractionDigits: 0,
                  })
                }}%
              </td>
            </tr>
          </table>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import { ref, watch, onMounted } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";
import annotationPlugin from "chartjs-plugin-annotation";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels,
  annotationPlugin
);

ChartJS.defaults.font.family =
  'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif';

import { toolTipDefault } from "@/utils/settings";
import { colors } from "@/utils/config";

export default {
  name: "FgBttm",
  components: {},
  props: ["data", "options", "id", "quartalSplit"],
  setup(props) {
    const chart = ref();
    const quartalText = ref();
    const dataset = [];
    let rowLabels = [];
    let chartRendered = false;
    let chartData;

    const chartOptions = {
      maintainAspectRatio: true,
      responsive: false,
      indexAxis: "y",
      backgroundColor: "#ed705a",
      categoryPercentage: 0.8,

      layout: {
        autoPadding: false,
        padding: {
          left: 0,
          right: 75,
          top: 0,
          bottom: 0,
        },
      },
      plugins: {
        autocolors: false,
        legend: {
          position: "bottom",
          align: "right",
          labels: {
            boxWidth: 15,
            boxHeight: 15,
            usePointStyle: true,
            filter: (legendItem, chartData) => {
              if (legendItem.text == undefined) return;
              return legendItem;
            },
          },
        },
        tooltip: {
          ...toolTipDefault,
          callbacks: {
            title: function (context) {
              const vj = context[0].datasetIndex > 0 ? " VJQ" : "";
              return rowLabels[context[0].dataIndex] + vj;
            },
            label: function (context) {
              return (
                (Math.round(context.raw / 10) / 100).toLocaleString("de-DE", {
                  minimumFractionDigits: 1,
                  maximumFractionDigits: 1,
                }) + " Tsd. €"
              );
            },
          },
        },
        datalabels: {
          color: "#304052",
          align: "right",
          anchor: "end",
          padding: {
            left: 0,
          },
          font: {
            size: 13,
            family:
              'Calibri, Carlito, Candara, Segoe, "Segoe UI", Optima, Arial, sans-serif',
            weight: 200,
          },
          formatter: (value, context) => {
            const compDatasetIndex = context.datasetIndex === 1 ? 0 : 1;
            const compVal = dataset[compDatasetIndex][context.dataIndex];
            // if (value > compVal) {
            return (
              (Math.round(value / 10) / 100).toLocaleString("de-DE", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              }) + " Tsd. €"
            );
            //}
            return "";
          },
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
          },
        },
        y: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            display: false,
          },
        },
      },
    };

    onMounted(() => {
      updateDataset();
      createChart();
    });

    const createChart = () => {
      const options = {
        type: "bar",
        data: chartData,
        options: chartOptions,
      };
      if (!chartRendered) {
        chartRendered = new ChartJS(chart.value, options);
      }
    };

    const updateDataset = () => {
      quartalText.value =
        "Q " + props.quartalSplit[0] + "-" + props.quartalSplit[1];
      rowLabels = props.data.map((row) => row[2]);
      dataset[0] = props.data.map((row) => row[5]);
      dataset[1] = props.data.map((row) => row[6]);
      chartData = {
        datasets: [
          {
            data: dataset[0],
            backgroundColor: colors.fgBttm,
            barPercentage: 1,
            minBarLength: 3,
          },
          {
            data: dataset[1],
            backgroundColor: colors.brown,
            barPercentage: 1,
            minBarLength: 3,
            label: "Q " + (props.quartalSplit[0] - 1) + "-" + props.quartalSplit[1],
          },
        ],
        labels: dataset[0],
      };

      if (chartRendered) {
        chartRendered.data.labels.pop();
        chartRendered.data = chartData;
        chartRendered.update();
      }
    };

    watch(
      () => props.data,
      (val, prevVal) => {
        updateDataset();
      }
    );

    return {
      //chartOptions,
      //chartData,
      quartalText,
      chart,
    };
  },
};
</script>

<style scoped>
#kz_veraenderung {
  display: inline-block;
  height: 224px;
  width: 140px;
  overflow: visible;
  margin-top: -5px;
}
</style>
